import React from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'react-bootstrap'
import { DateTimePicker } from 'react-widgets';

import Moment from 'moment'
import momentLocalizer from 'react-widgets-moment'
import { Flex, NumericInput, LabelGroup, Section } from '~/views';
import BaseTimerEditor from './BaseTimerEditor'

import { TimerActionFactory } from '../timerAction'
import style from './style.css'

Moment.locale( 'utc' )
momentLocalizer()

export default class OnceTimerEditor extends React.Component {
  static propTypes = {
    timer : PropTypes.object,
    currentContext : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  static TYPE = 'once'

  static DEFAULTS = {
    type : 'once',
    delay : 10000,
    when : undefined
  }

  constructor( props ) {
    super( props )
    this.state = {
      when : props.timer.timer.when != null
    }
  }

  changePath = ( path, value, err ) => {
    console.log( path, value, err )
    if ( err ) {
      console.log( `error setting ${key} to ${value}` )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  render() {
    // this.baseTimer.changePath( 'timer/when', v, err )
    const { timer, currentContext } = this.props
    const { when } = this.state
    const timerObj = timer.timer

    return (
      <div className={style.container}>
        <BaseTimerEditor ref={ref => this.baseTimer = ref} {...this.props} />
        <Section title="Timer">
          <Flex variant="vSpace" align="stretch" direction="column">
            {BaseTimerEditor.getDisplayTypeDropdown( timerObj, this.changePath )}
            <LabelGroup>
              <label />
              <ButtonGroup className="pull-right">
                <Button bsStyle={when === false ? 'primary' : 'default'} onClick={() => this.setState( { when : false } )}>Delay</Button>
                <Button bsStyle={when === true ? 'primary' : 'default'} onClick={() => this.setState( { when : true } )}>When</Button>
              </ButtonGroup>
            </LabelGroup>
            {
              !when &&
              (
                <LabelGroup>
                  <label>Delay</label>
                  <NumericInput
                    float
                    value={timerObj.delay}
                    changeOnReturn
                    size={10}
                    onChange={( v, err ) => { this.baseTimer.changePath( 'timer/delay', v, err ) }} />
                </LabelGroup>
              )
            }
            {
              when &&
              (
                <LabelGroup>
                  <label>When</label>
                  <DateTimePicker
                    onChange={( v ) => { this.baseTimer.changePath( 'timer/when', ( new Date( v ) ).getTime(), false ) }}
                    format="YYYY-MM-DDTHH:mm:ss.SSS"
                    value={timerObj.when ? new Date( timerObj.when ) : null} />
                </LabelGroup>
              )
            }
          </Flex>
        </Section>
        { TimerActionFactory.createEditor( timer.action, { ...this.props } ) }
        { BaseTimerEditor.getDisplayContext( timer, currentContext ) }
      </div>
    )
  }

}
